var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2722_2015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.29166C5.71331 2.29166 2.2915 5.74354 2.2915 10C2.2915 10.3452 2.01168 10.625 1.6665 10.625C1.32133 10.625 1.0415 10.3452 1.0415 10C1.0415 5.05645 5.0197 1.04166 9.99984 1.04166C12.9646 1.04166 15.1847 2.28 16.6512 3.5034C17.0607 3.84501 17.413 4.18654 17.7082 4.50168V2.13333C17.7082 1.78815 17.988 1.50833 18.3332 1.50833C18.6783 1.50833 18.9582 1.78815 18.9582 2.13333V6.3C18.9582 6.64518 18.6783 6.925 18.3332 6.925H14.6332C14.288 6.925 14.0082 6.64518 14.0082 6.3C14.0082 5.95482 14.288 5.675 14.6332 5.675H17.0826C16.7715 5.31449 16.3606 4.8888 15.8505 4.46326C14.54 3.36999 12.5934 2.29166 9.99984 2.29166ZM18.3332 9.375C18.6783 9.375 18.9582 9.65482 18.9582 10C18.9582 14.9452 14.945 18.9583 9.99984 18.9583C7.48279 18.9583 5.48691 17.6915 4.15078 16.4796C3.79612 16.1579 3.48396 15.8366 3.2165 15.5379V17.8667C3.2165 18.2118 2.93668 18.4917 2.5915 18.4917C2.24633 18.4917 1.9665 18.2118 1.9665 17.8667V13.7C1.9665 13.3548 2.24633 13.075 2.5915 13.075H6.35817C6.70335 13.075 6.98317 13.3548 6.98317 13.7C6.98317 14.0452 6.70335 14.325 6.35817 14.325H3.82242C4.12308 14.6905 4.51519 15.1226 4.99056 15.5537C6.2086 16.6585 7.91689 17.7083 9.99984 17.7083C14.2547 17.7083 17.7082 14.2548 17.7082 10C17.7082 9.65482 17.988 9.375 18.3332 9.375Z",
    fill: "#F1E7FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2722_2015)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "var(--secondaryText)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon2);
export default __webpack_public_path__ + "static/media/refresh-icon-2.f9703608341cf221a356cc3672661b33.svg";
export { ForwardRef as ReactComponent };